import React, { useEffect, useState } from "react";
import { Message } from "@arco-design/web-react";
import { useAuth0 } from "@auth0/auth0-react";

import { PostApi } from "../Api/AuthenticatedApi";
import ContactListAddEditDialog from "./ContactListAddEditDialog";

// Controlled "create a contact list" dialog, reusable wherever a user is picking
// a list and needs a new one (campaign / broadcast audience pickers, etc.). Owns
// the form fields + POST /api/contact-lists/. The create endpoint returns the
// persisted record, so onCreated hands the full list (with id) straight back —
// the caller can insert it into its options and select it without a refetch.
//
// Props:
//   open              show the dialog
//   onClose()         the user cancelled or the dialog closed itself after save
//   onCreated(list)   a list was created — receives the full ContactList record
export default function NewContactListDialog({ open, onClose, onCreated }) {
  const { getAccessTokenSilently } = useAuth0();
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  // Start each open blank.
  useEffect(() => {
    if (open) {
      setName("");
      setDescription("");
    }
  }, [open]);

  const save = () => {
    PostApi(
      getAccessTokenSilently,
      "/api/contact-lists/",
      (created) => {
        Message.success("Contact list created");
        onCreated && onCreated(created);
      },
      () => {},
      () => Message.error("Failed to create contact list"),
      { name: name.trim(), description }
    );
  };

  return (
    <ContactListAddEditDialog
      open={open}
      onSave={save}
      onClose={onClose}
      listName={name}
      setListName={setName}
      listDescription={description}
      setListDescription={setDescription}
      listId={""}
    />
  );
}
